import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Modal,
  connectModal,
  Button,
  AccordionItem,
  CounterTag,
  AFPTable,
} from '@gsa/afp-component-library';
import { emDashUnicode } from '../../../../utilities/constants';
import './carryover-lines-modal.scss';
import { getETDateTimeStr } from '../../components/contract-helpers';

const CarryoverLinesModal = ({
  contractHeader,
  lines,
  isOpen = false,
  onClose,
}) => {
  const contractYear =
    contractHeader.renewalYear ?? contractHeader.contractYear;
  const activeLines = lines.filter(
    (line) => line.orderEndDate && new Date(line.orderEndDate) > new Date(),
  );
  // const inactiveLines = lines.filter(
  //   (line) => !line.orderEndDate || new Date(line.orderEndDate) <= new Date(),
  // );

  const LineItemsGroup = ({ title, lineItems, initExpanded }) => {
    const [expanded, setExpanded] = useState(initExpanded);

    const columns = [
      {
        Header: 'Contract line',
        accessor: 'scheduleLine',
        sortable: false,
        Cell: ({ row: { original } }) => {
          return (
            <Link
              to={`/catalog/contract/${contractHeader.contractHeaderId}/contract-line-template/${original.id}`}
              className="text-bold margin-left-1"
            >
              {original?.scheduleLine || emDashUnicode}
            </Link>
          );
        },
      },
      {
        Header: 'Body make',
        accessor: 'make.makeName',
        sortable: false,
        Cell: ({ row }) => {
          const { make } = row?.original || {};
          return `${make?.makeName || emDashUnicode}`;
        },
      },
      {
        Header: 'Body model',
        accessor: 'model.modelName',
        sortable: false,
        Cell: ({ row }) => {
          const { model } = row?.original || {};
          return `${model?.modelName || emDashUnicode}`;
        },
      },
      {
        Header: 'Chassis make',
        accessor: 'chassisMake.makeName',
        sortable: false,
        Cell: ({ row }) => {
          const { chassisMake } = row?.original || {};
          return `${chassisMake?.makeName || emDashUnicode}`;
        },
      },
      {
        Header: 'Chassis model',
        accessor: 'chassisModel.modelName',
        sortable: false,
        Cell: ({ row }) => {
          const { chassisModel } = row?.original || {};
          return `${chassisModel?.modelName || emDashUnicode}`;
        },
      },
      {
        Header: 'Open date/time (ET)',
        accessor: 'orderStartDate',
        sortable: false,
        Cell: ({ row }) => {
          const { orderStartDate } = row?.original || {};
          return getETDateTimeStr(orderStartDate);
        },
      },
      {
        Header: 'Closeout date/time (ET)',
        accessor: 'orderEndDate',
        sortable: false,
        Cell: ({ row }) => {
          const { orderEndDate } = row?.original || {};
          return getETDateTimeStr(orderEndDate);
        },
      },
    ];

    return (
      <AccordionItem
        id={title}
        expanded={expanded}
        title={
          <div className="display-flex flex-row flex-justify padding-right-2">
            <div>{title}</div>
            <CounterTag count={lineItems.length} />
          </div>
        }
        content={<AFPTable columns={columns} data={lineItems} />}
        handleToggle={() => setExpanded(!expanded && lineItems.length > 0)}
      />
    );
  };
  LineItemsGroup.propTypes = {
    lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    title: PropTypes.string.isRequired,
    initExpanded: PropTypes.bool,
  };

  return (
    <Modal
      id="copy-line-item-modal"
      variant="extra-large"
      title={
        <div className="title-l">
          Contract lines carried over from contract year {contractYear}
        </div>
      }
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <div>
          <Button
            data-testid="cancel-append-line-btn"
            variant="unstyled"
            onClick={onClose}
            label="Close"
          />
        </div>
      }
    >
      <div className="minh-mobile contract-carryover-lines-modal">
        <div className="margin-y-4 font-ui-md">
          <div className="margin-bottom-05 text-bold text-primary">
            {contractYear} CONTRACT
          </div>
          <div className="margin-left-2">
            Published in Fleet: {contractHeader.publishedInFleet ? 'Yes' : 'No'}
            <br />
            <Link
              to={`/catalog/contract/contract-header/${contractHeader.contractHeaderId}/lines`}
            >
              View {contractYear} contract lines
            </Link>
          </div>
        </div>

        <LineItemsGroup
          title="Extended contract lines"
          lineItems={activeLines}
          initExpanded
        />
        {/* <LineItemsGroup title="Inactive lines" lineItems={inactiveLines} /> */}
      </div>
    </Modal>
  );
};

CarryoverLinesModal.propTypes = {
  contractHeader: PropTypes.shape({
    contractHeaderId: PropTypes.string.isRequired,
    renewalYear: PropTypes.number.isRequired,
    publishedInFleet: PropTypes.bool.isRequired,
  }).isRequired,
  lines: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default connectModal(CarryoverLinesModal);
